import LegalDocument from './LegalDocument';

export const TermsOfService = () => (
  <LegalDocument title="Terms of Service" document_type="terms_of_service" />
);

export const PrivacyPolicy = () => (
  <LegalDocument title="Privacy Policy" document_type="privacy_policy" />
);
